// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".resultContainer--1Gjcwmrj {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: var(--card-content-gap);\n  gap: 20px;\n}\n\n  .resultContainer--1Gjcwmrj .icon--3eNcCdfh {\n    height: 130px;\n    font-size: 100px;\n    color: var(--editor-brick-stroke-color);\n  }\n\n  .resultContainer--1Gjcwmrj .contentWrapper--2YYWcZXT {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .resultContainer--1Gjcwmrj .contentWrapper--2YYWcZXT .content--1j217at9 {\n      height: 20px;\n      width: 220px;\n      background-color: var(--editor-brick-skeleton-bg-light);\n    }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"resultContainer": "resultContainer--1Gjcwmrj",
	"icon": "icon--3eNcCdfh",
	"contentWrapper": "contentWrapper--2YYWcZXT",
	"content": "content--1j217at9"
};
export default ___CSS_LOADER_EXPORT___;
